const types = {
	status: 'status',
	approve: 'approve',
	rejected: 'rejected',
	pending: 'pending'
};

const locale = {
	ru: {
		status: 'при смене статуса',
		approve: 'только подтверженные',
		rejected: 'отмененные',
		pending: 'при создании'
	},
	en: types,
	uk: types,
	de: {
		status: 'Status',
		approve: 'nur bestätigte',
		rejected: 'abgelehnt',
		pending: 'beim Erstellen'
	},
	vi: types,
	th: {
		status: 'ในกรณีเปลี่ยนสถานะ',
		approve: 'ยืนยันแล้วเท่านั้น',
		rejected: 'ถูกปฏิเสธ',
		pending: 'เมื่อสร้าง'

	}
};

module.exports = {
	enum: types,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/postback-types.js